export default __webpack_public_path__ + "static/media/10.21.25 Minutes Reg Mtg.aeb38d70.pdf";